import { useProductSearchStore } from "@/store/product-search";
import { useDatalayerStore } from "@/store/datalayer";
import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";
import SearchPageCodes from "@/utils/page-recherche-codes";
import { pushProps, usePush } from "@/components/pages/mixins/push-mixin"
import { useContainerProductList } from "@/containers/mixin/product-list.mixin";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const pageProductSearchProps = () => ({
  previousPage: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  showAboLad: {
    type: Boolean,
    required: false,
    default: false
  },
  showAboLadRenouvellement: {
    type: Boolean,
    required: false,
    default: false
  },
  ...pushProps()
})

export const usePageProductSearch = (props) => {
  const productSearchStore = useProductSearchStore()

  const { getPushData } = usePush(props.pushZones)

  const {
    pagination,
    keyWord,
    filters,
    appliedFilters,
    filterVisible,
    productsList,
    sortCriteria,
    productsListMode,
    firstPageIndex,
    lastPageIndex,
    sections,
    isLoadingInfinite
  } = storeToRefs(productSearchStore)

  const { searchFetchFiltredProducts, loadNextSearchPage, onProductIntersect } =
    useContainerProductList(
      productsList.value,
      sortCriteria.value,
      appliedFilters.value
    );

  const { updateFilterVisible, setShowMoreClicked, setShowPreviousClicked } = productSearchStore

  const { setLocation } = useDatalayerStore()

  const { trackEvent } = useInteractionDoneTracking();

  const ourSelection = computed(() => {
    const selectedProducts =
      props.pushZones &&
      props.pushZones.find(
        (e) => e.code === pagesNiv3et4Codes.Niv3_4_PRODUITS
      );
    return selectedProducts ? selectedProducts.products : [];
    return []
  })

  const recettePositions = computed(() => {
    return useRuntimeConfig().public.MIAM_SEARCH_POSITIONS;
  })

  const pushPositionsObject = computed(() => {
    return useRuntimeConfig().public.MERCH_SEARCH_POSITIONS_GRID;
  })

  const toggleFilter = (value) => {
    updateFilterVisible(value !== undefined ? value : !filterVisible.value);
    if (filterVisible.value) {
      trackEvent({
        actionGA: trackingCodes.ACTIONGA.plusDeFiltres,
        categoryGA: trackingCodes.CATEGORYGA.filter,
      });
    }
  }

  const getOurSelectionPush = (code) => {
    const pushElement =
      props.pushZones && props.pushZones.find(e => e.code === code);
    return pushElement && pushElement.html_content !== "null"
      ? pushElement
      : null;

    return null
  }
  const isAbonnementLad = (zoneMerch) => {
    return zoneMerch && zoneMerch.html_content && zoneMerch.html_content.includes("abonnement_lad");
  }

  const mounted = () => {
    setLocation("recherche")
  }

  return {
    pagesNiv3et4Codes,
    pagination,
    keyWord,
    filters,
    appliedFilters,
    ourSelection,
    filterVisible,
    pagePushZonesGridCodes: SearchPageCodes.GRID,
    productsList,
    productsListMode,
    firstPageIndex,
    lastPageIndex,
    recettePositions,
    pushPositionsObject,
    sections,
    isLoadingInfinite,
    searchFetchFiltredProducts,
    loadNextSearchPage,
    onProductIntersect,
    setShowMoreClicked,
    setShowPreviousClicked,
    toggleFilter,
    getOurSelectionPush,
    isAbonnementLad,
    getPushData,
    mounted,
  }
}